import { FC } from 'react';

import { TablePagination } from 'modules/_shared/Table/components/TablePagination';

import { useOperationsListPage } from '../context/OperationsListPageContext';
import OperationsTable from './OperationsTable';

const OperationsListPageBody: FC = () => {
  const { data, actions } = useOperationsListPage();

  const showPagination =
    data.operations && data.operationsTotal > (data.rowsPerPage || 10);

  return (
    <div className="nk-block">
      <OperationsTable />

      {showPagination && (
        <TablePagination
          totalRows={data.operationsTotal || 0}
          onChangePage={actions.handleChangePage}
          onChangeRowsPerPage={actions.handleChangeRowsPerPage}
        />
      )}
    </div>
  );
};

export default OperationsListPageBody;
